<template>
    <div class="p-3">
        <h3>25 Besar Penyakit Rawat Jalan</h3>
        <hr>

        <div class="row mt-3">
            <h4 class="mb-3">Pencarian Data</h4>

            <div class="col-sm-3">
                <div class="mb-3 row">
                    <label for="year" class="col-sm-4 col-form-label text-end">Bulan</label>
                    <div class="col-sm-8">
                        <!-- <v-select v-model="year" :clearable="false" :multiple="false" :options="data_year" label="name"
                            name="year" id="year" placeholder="Pilih Tahun" :single="true" @input="setYear($event)" /> -->
                            <input v-model="year" type="month" class="form-control" name="year" id="year">

                    </div>
                </div>
            </div>
            <div class="col-sm-2">
                <div class="mb-3">
                    <div class="col-sm-8 text-end">
                        <button class="btn btn-primary" @click="getPel"><i class="fa fa-search"></i>
                            Cari</button>
                    </div>

                </div>
            </div>

        </div>
        <hr />

        <div class="card mb-3">
            <div class="card-header text-white bg-primary">Data 25 Besar Penyakit Rawat Jalan</div>
            <div class="card-body">
                <div id="table">
                    <table class="table table-bordered">
                        <thead>
                            <tr>
                                <th rowspan="2" style="vertical-align: top; text-align: center;">Kode RS</th>
                                <th rowspan="2" style="vertical-align: top; text-align: center;">Nama RS</th>
                                <th rowspan="2" style="vertical-align: top; text-align: center;">Kab/Kota</th>
                                <th rowspan="2" style="vertical-align: top; text-align: center;">Bulan</th>
                                <th rowspan="2" style="vertical-align: top; text-align: center;">Tahun</th>
                                <th rowspan="2" style="vertical-align: top; text-align: center;">Kode ICD</th>
                                <th rowspan="2" style="vertical-align: top; text-align: center;">Diagnosa</th>
                                <th colspan="2" style="vertical-align: top; text-align: center;">Pasien Keluar Hidup & Mati</th>
                                <th rowspan="2" style="vertical-align: top; text-align: center;">Jumlah Pasien Keluar Hidup</th>
                                <th rowspan="2" style="vertical-align: top; text-align: center;">Jumlah Pasien Keluar Mati</th>
                                <th rowspan="2" style="vertical-align: top; text-align: center;">Total</th>
                            </tr>
                            <tr>
                                <th>LK</th>
                                <th>LP</th>
                            </tr>
                        </thead>
                        <tbody v-for="(item, index) in data_pel" :key="index">
                            <tr>
                                <td style="text-align: center;">
                                    {{ NomorKodeRS }}
                                </td>
                                <td style="text-align: center;">
                                    {{ NamaRS }}
                                </td>
                                <td style="text-align: center;">
                                    {{ KotaKab }}
                                </td>
                                <td style="text-align: center;">
                                    {{ bulanString(bulan)  }}
                                </td>
                                <td style="text-align: center;">
                                    {{ tahun }}
                                </td>
                                <td style="text-align: center;">
                                    {{ item.KdICD }}
                                </td>
                                <td style="text-align: center;">
                                    {{ item.Diagnosa }}
                                </td>
                                <td style="text-align: center;">
                                    {{ item.jumlah_pria }}
                                </td>
                                <td style="text-align: center;">
                                    {{ item.jumlah_wanita }}
                                </td>
                                <td style="text-align: center;">
                                    {{ item.pasien_meninggal }}
                                </td>
                                <td style="text-align: center;">
                                    {{ item.pasien_hidup }}
                                </td>
                                <td style="text-align: center;">
                                    {{ item.total }}
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import vSelect from 'vue-select';
import 'vue-select/dist/vue-select.css';

export default {
    components: {
        'v-select': vSelect
    },
    data() {
        return {
            year: '',
            NomorKodeRS: '',
            NamaRS: '',
            KotaKab: '',
            bulan: '',
            tahun: '',
            data_year: [],
            data_pel: [],

        }
    },
    created() {
    },
    mounted() {
        this.getPel()
    },
    methods: {
        getPel() {
            const uri = `/api/external-penyakit-rajal/get-pel?year=${this.year}`

            this.axios.get(uri).then(response => {
                const status = response.data.status
                // console.log(status);
                // console.log(response.data.data);

                if (status == 'success') {
                    this.NomorKodeRS = response.data.data_rs.NomorKodeRS;
                    // console.log(response.data.data_rs);
                    this.NamaRS = response.data.data_rs.NamaRS;
                    this.KotaKab = response.data.data_rs.KotaKab;
                    this.bulan = response.data.bulan;
                    this.tahun = response.data.tahun;
                    this.data_pel = response.data.data
                    this.data_pel = { ...this.data_pel }
                }
            });

        },
       
        bulanString(month) {
            var data = '';
            if (month == 1) {
                data = 'Januari';
            } else if(month == 2) {
                data = 'Febuari';
            } else if(month == 3) {
                data = 'Maret';
            } else if(month == 4) {
                data = 'April';
            } else if(month == 5) {
                data = 'Mei';
            } else if(month == 6) {
                data = 'Juni';
            } else if(month == 7) {
                data = 'July';
            } else if(month == 8) {
                data = 'Agustus';
            } else if(month == 9) {
                data = 'September';
            } else if(month == 10) {
                data = 'Okttober';
            } else if(month == 11) {
                data = 'November';
            } else if(month == 12) {
                data = 'Desember';
            }
            return data;
        }
    }
}
</script>